import React from "react";

import styled from "styled-components/macro";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";

export default function EditButton({ onClick }) {
  return (
    <Wrapper>
      <FnrButton
        data-cy="editRecurringBtn"
        color="blue"
        fullWidth
        onClick={onClick}
      >
        <ButtonIcon fas fa-pencil />
        <ButtonText>Edit</ButtonText>
      </FnrButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex: 1;
`;
